<p-autoComplete
  [(ngModel)]="selectedItem"
  [suggestions]="suggestions"
  (completeMethod)="onSearch($event)"
  [placeholder]="placeholder"
  field="name"
  [dropdown]="false"
  [multiple]="false"
  [minLength]="3"
  [delay]="300"
  [showClear]="true"
  [forceSelection]="false"
  (onSelect)="onItemSelect($event)"
  (onClear)="onClear()"
  styleClass="w-full"
  appendTo="body"
>
  <ng-template let-item pTemplate="item">
    <div class="flex align-items-center gap-3 p-2">
      <!-- Imagen del producto -->
      <img
        [src]="item.images?.['250']?.[0] || item.image || '/assets/images/no-image.png'"
        [alt]="item.name"
        class="border-round"
        style="width: 40px; height: 40px; object-fit: cover"
        onerror="this.src='/assets/images/no-image.png'"
      />

      <!-- Información del producto -->
      <div class="flex-grow-1">
        <div class="font-medium text-900">{{ item.name }}</div>
        <div class="text-sm text-color-secondary font-bold">
          {{ item.sku }}
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="empty">
    <div class="text-center p-3">
      @if (!articuloLoading) {
      <div class="text-600">
        <i class="pi pi-search mr-2"></i>
        Escribe al menos 3 caracteres para buscar productos
      </div>
      } @if (articuloLoading) {
      <div class="text-600">
        <i class="pi pi-spin pi-spinner mr-2"></i>
        Buscando productos...
      </div>
      }
    </div>
  </ng-template>
</p-autoComplete>
